import { actionTypes } from '../../actionTypes';
import * as apiRoutes from '../../apiRoutes';
import { ErrorData, APIUrl } from '../../constants';
import * as api from '../../tools/apiMiddleware';

const initialState = { isLoading: false, lists: [], hasErrorOccured: false, errorData: ErrorData };
let editablePublicationId;
let deletedPublicationId;
export const actionCreators = {
    getPublicationLog: (programmeId, publicationId) => async (dispatch, getState) => {
        editablePublicationId = publicationId;

        let url = APIUrl + apiRoutes.Publication + '/' + programmeId;
        await api.getRequest(dispatch, url, actionTypes.GET_PUBLICATION_LOG, actionTypes.GET_PUBLICATION_LOG_SUCCESS, actionTypes.GET_PUBLICATION_LOG_FAIL);

    },
    deletePublication: (programmeId, publicationId) => async (dispatch, getState) => {

        deletedPublicationId = publicationId;
        let url = APIUrl + `${apiRoutes.Publication}/${programmeId}/${publicationId}`;
        await api.deleteRequest(dispatch, url, actionTypes.DELETE_PUBLICATION, actionTypes.DELETE_PUBLICATION_SUCCESS, actionTypes.DELETE_PUBLICATION_FAIL);

    },
    updatePublication: (programmeId, data) => async (dispatch, getState) => {

        let url = APIUrl + apiRoutes.Publication + `/${programmeId}`;
        await api.updateRequest(dispatch, url, data, actionTypes.UPDATE_PUBLICATION, actionTypes.UPDATE_PUBLICATION_SUCCESS, actionTypes.UPDATE_PUBLICATION_FAIL);
        editablePublicationId = 0;
        await api.getRequest(dispatch, url, actionTypes.GET_PUBLICATION_LOG, actionTypes.GET_PUBLICATION_LOG_SUCCESS, actionTypes.GET_PUBLICATION_LOG_FAIL);

    },
    clearErrorMessage: () => (dispatch, getState) => {

        dispatch({ type: actionTypes.PUBLICATION_LOG_CLEAR_ERROR });

    }
};

export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case actionTypes.GET_PUBLICATION_LOG:
            return {
                ...state,
                isLoading: true,
                lists: state.lists,
                hasErrorOccured: false,
                recordDeleted: false
            };
        case actionTypes.GET_PUBLICATION_LOG_SUCCESS:
            return {
                ...state,
                lists: action.data,
                editablePublicationId: editablePublicationId,
                isLoading: false,
                hasErrorOccured: false,
                recordDeleted: false
            };
        case actionTypes.GET_PUBLICATION_LOG_FAIL:
            return {
                ...state,
                isLoading: false,
                lists: state.lists,
                hasErrorOccured: true,
                errorData: action.data,
                recordDeleted: false
            };
        case actionTypes.DELETE_PUBLICATION:
            return {
                ...state,
                isLoading: true,
                lists: state.lists,
                hasErrorOccured: false,
                recordDeleted: false
            };
        case actionTypes.DELETE_PUBLICATION_SUCCESS:

            return {
                ...state,
                isLoading: false,
                lists: state.lists.filter(x=> x.id !== deletedPublicationId),
                hasErrorOccured: false,
                recordDeleted: true
            };
        case actionTypes.DELETE_PUBLICATION_FAIL:
            return {
                ...state,
                isLoading: false,
                lists: state.lists,
                hasErrorOccured: true,
                errorData: action.data
            };
        case actionTypes.PUBLICATION_LOG_CLEAR_ERROR:
            return {
                ...state,
                isLoading: false,
                lists: state.lists,
                hasErrorOccured: false
            };
        case actionTypes.UPDATE_PUBLICATION:
            return {
                ...state,
                data: state.data,
                isLoading: true
            };
        case actionTypes.UPDATE_PUBLICATION_SUCCESS:
            return {
                ...state,
                data: state.data,
                isLoading: false
            };
        case actionTypes.UPDATE_PUBLICATION_FAIL:
            return {
                ...state,
                isLoading: false,
                data: state.data,
                hasErrorOccured: true,
                errorData: action.data
            };
    }

    return state;
};




// WEBPACK FOOTER //
// ./src/store/NonLinear/PublicationLogStore.js